import { DateService } from './../../services/date.service';
import { MeetingService } from './../../services/meeting.service';
import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbDate, NgbDateStruct, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs/operators';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from 'src/app/config/app.constant';
import { AppStateProvider } from 'src/app/providers/app-state.provider';
import { ApiService } from 'src/app/services/api.service';

@Component({
  standalone: false,
  selector: 'app-book-meeting-room',
  templateUrl: './book-meeting-room.component.html',
  styleUrls: ['./book-meeting-room.component.scss']
})
export class BookMeetingRoomComponent implements OnInit, OnDestroy {
  model;
  now: string;
  nedate: NgbDate;
  backENdData = {};
  bookedData = [];
  timeStamps = [];
  searchText: string = '';
  // time = {hour: 13, minute: 30};
  // time = new Date();
  timer;
  time;
  duration;
  timeToDisplay;
  meridian = false;
  valuedate: any;
  highlight: boolean = false;
  meetingNav;
  date;
  // duration:number=1;
  newTime: string;
  display: string;
  amorpm: boolean = true;
  displayDuration: string;
  displayTotalTime: string;
  url: any;
  token: any;
  meetingroomlist: any;
  timelineData: any;
  timeLine = [];
  Data = [];
  availableSlot = [];
  flexibleData = [];
  availableData = [];
  emailList: any;
  selectedIndex: any;
  bookingDate: string;
  bookingDateinDt: Date;
  displayDetails: string;
  displayTotalTimedetails: string;
  displayDurationdetails: any;
  selectedEmail: any = null;
  normalizeMinute;
  normalizeTime;
  normalamorpm;
  minDate: { year: number; month: number; day: number };
  availableCredits: number = 0;
  userCredits: any;
  disableTime: boolean = false;
  popOver = null;
  formatDate: string = '';
  isDurationError: boolean = false;
  constructor(
    private apiService: ApiService,
    public datepipe: DatePipe,
    private router: Router,
    private appStateSrv: AppStateProvider,
    private meetingSrv: MeetingService,
    private ngbDatepickerConfig: NgbDatepickerConfig,
    private dateSrv: DateService
  ) {
    this.duration = { hour: 0, minute: 30 };
    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate(),
    };

    ngbDatepickerConfig.minDate = {
      year: current.getFullYear(), month:
        current.getMonth() + 1, day: current.getDate()
    };
    //config.maxDate = { year: 2099, month: 12, day: 31 };
    ngbDatepickerConfig.outsideDays = 'hidden';
    this.backENdData = {};
    this.bookedData = [];
  }
  initiaizeStartTime() {
    let amorpm;
    // this.timer = setInterval(() => {
    this.date = new Date();
    this.timeToDisplay = new Date();
    let changeHour = Number(localStorage.getItem(AppConstant.localStorage.changeHour));
    let changeMinute = Number(localStorage.getItem(AppConstant.localStorage.changeMinute));
    let changeamorpm = localStorage.getItem(AppConstant.localStorage.changeamorpm);
    let hour = (changeHour || changeMinute) ? changeHour : this.timeToDisplay.getHours();
    let minute = (changeHour || changeMinute) ? changeMinute : this.timeToDisplay.getMinutes();

    let currenthour = hour == 0 ? 12 : hour;
    this.time = { hour: currenthour, minute: minute };
    this.newTime = `${this.time.hour}:${this.time.minute}`;
    if (currenthour + minute > 7)
      this.disableTime = true;
    this.getNormalizeMinute(this.time.minute);
    let normalizeHour = (this.normalizeMinute == 0 && minute != 0) ? this.time.hour + 1 : this.time.hour;
    normalizeHour = normalizeHour >= 13 ? normalizeHour - 12 : normalizeHour;

    // let hourForamorpm = changeamorpm ? this.timeToDisplay.getHours() : currenthour;
    // if (hourForamorpm >= 12) {
    //   amorpm = 'pm'
    // }
    // else {
    //   amorpm = 'am'
    // }
    if (changeamorpm == 'am' || changeamorpm == 'pm')
      amorpm = changeamorpm;
    else if (changeamorpm == 'null') {
      if (hour != 0 && (currenthour >= 12 || normalizeHour == 12)) {
        amorpm = 'pm';
      }
      else {
        amorpm = 'am';
      }
    }
    else {
      if (this.timeToDisplay.getHours() >= 12) {
        amorpm = 'pm';
      }
      else {
        amorpm = 'am';
      }
    }
    this.amorpm = amorpm == 'pm' ? true : false;

    this.newTime = `${this.time.hour}:${this.time.minute}`;
    this.normalizeTime = { hour: normalizeHour, minute: this.normalizeMinute };
    this.normalamorpm = amorpm;
    let len = this.normalizeTime.minute.toString().length;
    if (len == 1) {
      minute = '0' + this.normalizeTime.minute;
    }
    else {
      minute = this.normalizeTime.minute;
    }

    this.display = this.time.hour >= 13 ? normalizeHour + ':' + minute + ' ' + amorpm : normalizeHour + ':' + minute + ' ' + amorpm
    this.displayDetails = this.time.hour >= 13 ? normalizeHour + ':' + minute + ' ' + amorpm : normalizeHour + ':' + minute + ' ' + amorpm.toUpperCase()

    localStorage.setItem(
      AppConstant.localStorage.fromtime,
      this.displayDetails
    );
    localStorage.setItem(
      AppConstant.localStorage.changeamorpm,
      amorpm
    );
  }


  checkIfValidTimeline(toTime, startTime) {
    // const startTime = localStorage.getItem(AppConstant.localStorage.fromtime);
    // const toTime = localStorage.getItem(AppConstant.localStorage.toTime);
    if (startTime.split(' ')[1].toLowerCase() == 'pm' && toTime.split(' ')[1].toLowerCase() == 'am') {
      this.appStateSrv.showToast("Meeting time cannot exceed 11:45PM. Please select the valid time.");
      return false;
    }
    return true;
  }


  getNormalizeMinute(iminute) {
    if (iminute > 0 && iminute <= 15) {
      this.normalizeMinute = 15
    }
    else if (iminute > 15 && iminute <= 30) {
      this.normalizeMinute = 30
    }
    else if (iminute > 30 && iminute <= 45) {
      this.normalizeMinute = 45
    }
    else if (iminute > 45 && iminute <= 60) {
      this.normalizeMinute = 0;
    }
    else {
      this.normalizeMinute = 0;
    }
  }
  initializeDuration() {
    let amorpm;
    let min;
    const durationFromStorage = localStorage.getItem(AppConstant.localStorage.duration);
    if (durationFromStorage) {
      this.duration = {
        hour: Number(durationFromStorage.split('.')[0]),
        minute: Number(durationFromStorage.split('.')[1])
      }
    }
    else {
      this.duration = {
        hour: 0,
        minute: 30
      };
    }
    let normalizedurationHour = this.duration.hour == 1 ? this.duration.hour + ' hour' : this.duration.hour + ' hours'
    let normalizeMinutes = this.duration.minute == 0 ? '' : this.duration.minute + ' minutes'
    this.displayDuration = normalizedurationHour + ' ' + normalizeMinutes;
    if (this.duration.minute == 0) {
      let c = 0o0
    }
    else {
      let c = "bye"
    }
    this.displayDurationdetails = this.duration.hour + '.' + (this.duration.minute <= 0 ? "0" + this.duration.minute : this.duration.minute);

    // this.time = {hour: this.timeToDisplay.getHours(), minute: this.timeToDisplay.getMinutes()};
    // this.date= this.timeToDisplay.toLocaleTimeString('en-US')
    let hour = parseInt(this.duration.hour) + parseInt(this.normalizeTime.hour);
    let minutes = parseInt(this.duration.minute) + parseInt(this.normalizeTime.minute);
    // if (minutes >= 60) {
    //   hour = hour + 1
    // }
    let normalizeDisplayTime = hour >= 13 ? hour - 12 : hour
    if (this.normalamorpm == 'am') {
      amorpm = 'pm';
    }
    else {
      amorpm = 'am';
    }
    amorpm = hour >= 12 ? amorpm : this.normalamorpm;

    if (minutes <= 0) {
      min = "0" + minutes
    }
    else {
      min = minutes;
    }

    if (this.normalizeTime.hour >= 12 && this.normalamorpm == 'am')
      amorpm = 'am';
    if (this.normalizeTime.hour >= 12 && this.normalamorpm == 'pm')
      amorpm = 'pm';


    this.displayTotalTime = normalizeDisplayTime + ':' + (minutes <= 0 ? "0" + minutes : minutes) + ' ' + amorpm;
    this.displayTotalTimedetails = normalizeDisplayTime + ':' + min + ' ' + amorpm.toUpperCase();
    // if ((Number(this.displayTotalTimedetails.split(' ')[0].split(':')[0]) == 12 && this.displayTotalTimedetails.split(' ')[1].toLowerCase() == 'am') || (Number(this.displayTotalTimedetails.split(' ')[0].split(':')[0]) == 11 && Number(this.displayTotalTimedetails.split(' ')[0].split(':')[1]) > 45 && this.displayTotalTimedetails.split(' ')[1].toLowerCase() == 'pm')) {
    //   this.appStateSrv.showToast("Meeting time cannot exceed 11:45PM. Please select the valid time.");
    //   console.log('in initializeDuration');

    //   return;
    // }

    // if ((Number(this.displayTotalTimedetails.split(' ')[0].split(':')[0]) == 12 && this.displayTotalTimedetails.split(' ')[1].toLowerCase() == 'am') || (Number(this.displayTotalTimedetails.split(' ')[0].split(':')[0]) == 11 && Number(this.displayTotalTimedetails.split(' ')[0].split(':')[1]) > 45 && this.displayTotalTimedetails.split(' ')[1].toLowerCase() == 'pm') || (Number(this.displayTotalTimedetails.split(':')[0]) >= 1 && this.display.split(' ')[1] == 'pm' && this.displayTotalTimedetails.split(' ')[1].toLowerCase() == 'am')) {
    //   this.appStateSrv.showToast("Meeting time cannot exceed 11:45PM. Please select the valid time.");
    //   return;
    // }
    if (!this.checkIfValidTimeline(this.displayTotalTimedetails, this.displayDetails))
      return

    localStorage.setItem(
      AppConstant.localStorage.toTime,
      this.displayTotalTimedetails
    );
    localStorage.setItem(
      AppConstant.localStorage.duration,
      this.displayDurationdetails
    );
  }
  initializeSlider() {
    const current = new Date();
    if (current.getHours() >= 12) {
      this.amorpm = true;
    }
    else {
      this.amorpm = false;
    }
  }
  getApiauthorizationToken() {
    //this.commonService.getApiauthorizationToken().subscribe((res) => {
    if (localStorage.getItem(AppConstant.localStorage.token) != null) {
      this.getMeetingRoomList();
      this.getEmployeeEmailList();
    }
    //});
  };
  checkInbetweenTime(fromTime, timeTo) {
    let fromTimeArray = fromTime.split(':');
    this.display = ('0' + this.display.split(':')[0]).slice(-2) + ':' + this.display.split(':')[1]
    let displayTimeArray = this.display.split(':');
    // let toTime = localStorage.getItem(AppConstant.localStorage.toTime).split(':');
    let toTime = localStorage.getItem(AppConstant.localStorage.toTime);
    // toTime[0] = ('0' + toTime[0]).slice(-2);

    // if (fromTimeArray[0] == displayTimeArray[0]) {
    //   if (Number(fromTimeArray[1].split(' ')[0]) != Number(displayTimeArray[1].split(' ')[0]))
    //     return true;
    // }
    // return false;

    // if (fromTime.toUpperCase() == this.display.toUpperCase())
    //   return true;
    // else if (Number(fromTimeArray[0]) == Number(displayTimeArray[0]) && Number(fromTimeArray[1].split(' ')[0]) < Number(displayTimeArray[1].split(' ')[0]))
    //   return true;
    // else if (Number(fromTimeArray[0]) > Number(displayTimeArray[0]) && Number(fromTimeArray[0]) < Number(toTime[0]))
    //   return true;
    // else if (Number(fromTimeArray[0]) == Number(toTime[0]) && Number(fromTimeArray[1].split(' ')[0]) < Number(toTime[1].split(' ')[0]))
    //   return true;
    // else if ((Number(displayTimeArray[0]) <= Number(fromTimeArray[0])) && (Number(toTime[0]) == Number(fromTimeArray[0]) && Number(toTime[1].split(' ')[0]) > Number(fromTimeArray[1].split(' ')[0])))
    //   return true;
    // else
    //   return false;
    const timeConversion = (s) => {
      var time = s.toLowerCase().split(':');
      var hours = parseInt(time[0]);
      var _ampm = time[1].split(' ')[1].toLowerCase();
      if (_ampm.indexOf('am') != -1 && hours == 12) {
        time[0] = '00';
      }
      if (_ampm.indexOf('pm') != -1 && hours < 12) {
        time[0] = hours + 12;
      }
      return time.join(':').replace(/(am|pm)/, '');
    }
    let display1 = timeConversion(this.display);
    let fromTimeArray1 = timeConversion(fromTime);
    let toTimeArray1 = timeConversion(timeTo);
    let toTime1 = timeConversion(toTime);
    // console.log("DATATEST display1,", display1);
    // console.log("DATATEST fromTimeArray1,", fromTimeArray1);
    // console.log("DATATEST toTime1,", toTime1);

    const convertToTimestamp = (h: number, m: number, s = '00') => {
      let inputDateTime = localStorage.getItem(AppConstant.localStorage.selectedDate) + " " + ('0' + h).slice(-2) + ":" + ('0' + m).slice(-2) + ":" + s;
      // console.log('DATATEST', localStorage.getItem(AppConstant.localStorage.selectedDate) + "T" + ('0' + h).slice(-2) + ":" + ('0' + m).slice(-2) + ":" + s);

      return new Date(inputDateTime).getTime();
    }

    let fromHr = 0;
    let fromMin = 0;
    let toHr = 0;
    let toMin = 0;
    let meetingTimeHr = 0;
    let meetingTimeMin = 0;
    let meetingFTimeHr = 0;
    let meetingFTimeMin = 0;
    fromHr = Number(display1.split(':')[0]);
    fromMin = Number(display1.split(':')[1])

    toHr = Number(toTime1.split(':')[0]);
    toMin = Number(toTime1.split(':')[1]);
    // const date = new Date();

    meetingTimeHr = Number(fromTimeArray1.split(':')[0]);
    meetingTimeMin = Number(fromTimeArray1.split(':')[1])
    meetingFTimeHr = Number(toTimeArray1.split(':')[0]);
    meetingFTimeMin = Number(toTimeArray1.split(':')[1])
    // if (id == 3) {
    //   console.log('DATATEST from', convertToTimestamp(fromHr, fromMin));
    //   console.log('DATATEST to', convertToTimestamp(toHr, toMin));
    //   console.log('DATATEST meeting', convertToTimestamp(meetingTimeHr, meetingTimeMin));
    //   console.log('DATATEST ', (convertToTimestamp(fromHr, fromMin) <= convertToTimestamp(meetingTimeHr, meetingTimeMin)) && (convertToTimestamp(meetingTimeHr, meetingTimeMin) <= convertToTimestamp(toHr, toMin)));
    //   console.log('DATATEST --------------------------');
    // }


    if ((convertToTimestamp(fromHr, fromMin) <= convertToTimestamp(meetingTimeHr, meetingTimeMin) && convertToTimestamp(meetingTimeHr, meetingTimeMin) <= convertToTimestamp(toHr, toMin)) || (convertToTimestamp(fromHr, fromMin) <= convertToTimestamp(meetingFTimeHr, meetingFTimeMin) && convertToTimestamp(meetingFTimeHr, meetingFTimeMin) <= convertToTimestamp(toHr, toMin)) || (convertToTimestamp(fromHr, fromMin) >= convertToTimestamp(meetingTimeHr, meetingTimeMin) && convertToTimestamp(meetingFTimeHr, meetingFTimeMin) >= convertToTimestamp(toHr, toMin)))
      return true;
    else
      return false;


  }
  getMeetingRoomList() {
    this.url = APIs.getMeetingRoomListDetails;
    const paramObj = {
      // locationId: 1,
      locationId: localStorage.getItem(AppConstant.localStorage.locationId),
      date: localStorage.getItem(AppConstant.localStorage.bookingDate),
      duration: Number(localStorage.getItem(AppConstant.localStorage.duration))
    };
    this.apiService.get(this.url, paramObj).subscribe(
      (meetingRoomResp: any) => {
        this.meetingroomlist = meetingRoomResp;
        this.availableData = [];
        this.flexibleData = [];

        this.backENdData = {};
        this.bookedData = [];
        this.meetingroomlist.list.filter(x => x.meetingRoom.isActive).forEach((item) => {

          this.getTimeLineData(item.meetingRoom.id).subscribe((timeLineResp) => {
            this.timelineData = timeLineResp;
            this.availableSlot = [];
            this.Data = [];
            // this.timelineData=response;
            // this.meetingroomlist.list.forEach((data)=>{
            this.timeLine = this.timelineData.list;
            if (this.timeLine.length > 0) {
              this.timeLine.forEach((data) => {
                // if(data.fromTime==this.display.toUpperCase() && data.toTime==this.displayTotalTime.toUpperCase())
                // {

                if (this.checkInbetweenTime(data.fromTime, data.toTime) && data.status != 'Cancelled') {
                  if (this.flexibleData.length == 0 || !this.flexibleData.find(z => z.meetingRoom.id == data.meetingRoomId))
                    // this.flexibleData=[]
                    this.flexibleData.push(item);
                  // let availableSlot = {
                  //   startTime: localStorage.getItem(AppConstant.localStorage.fromtime),
                  //   endTime: localStorage.getItem(AppConstant.localStorage.toTime)
                  //   // endTime: '12:00 PM'
                  // }
                  // this.availableData.push(item);
                  // this.getTimelineTimeStamp([availableSlot], false, item.meetingRoom.id)
                  // console.log('DATATEST flexibleData ', this.flexibleData, data.meetingRoomId);

                }
                else {
                  // console.log('DATATEST availableData ', this.availableData, data.meetingRoomId);

                  if (this.flexibleData.some(z => z.meetingRoom.id == data.meetingRoomId) == false && this.availableData.some(z => z.meetingRoom.id == data.meetingRoomId) == false) {
                    this.availableData.push(item);
                    let availableSlot = {
                      startTime: this.display.toUpperCase(),
                      endTime: this.displayTotalTime.toUpperCase()
                      // endTime: '12:00 PM'
                    }
                    this.availableSlot.push(availableSlot);
                    this.getTimelineTimeStamp(this.availableSlot, false, item.meetingRoom.id);
                  }
                }
                let ids = [];
                let matchId = null;
                this.flexibleData.forEach(f => {
                  this.availableData.forEach(a => {
                    if (f.meetingRoom.id == a.meetingRoom.id)
                      ids.push(a.meetingRoom.id)
                  })
                })
                if (ids.length > 0)
                  for (let id in ids) {
                    matchId = this.availableData.findIndex(a => a.meetingRoom.id == ids[id]);

                    if (matchId !== null)
                      this.availableData = this.availableData.splice(0, matchId)
                  }

                let bookedSlot = {
                  startTime: data.fromTime,
                  endTime: data.toTime
                };
                this.Data.push(bookedSlot);
                this.getTimelineTimeStamp(this.Data, true, item.meetingRoom.id);

                // }
              })
              // }
            }
            else {
              // this.availableData=[]
              let availableSlot = {
                startTime: localStorage.getItem(AppConstant.localStorage.fromtime),
                endTime: localStorage.getItem(AppConstant.localStorage.toTime)
                // endTime: '12:00 PM'
              }
              this.availableData.push(item);
              this.getTimelineTimeStamp([availableSlot], false, item.meetingRoom.id)
            }
          })
          // this.getTimeLineData(data.id);
        })
      },
      err => console.log('error', err)
    );
  }
  getTimeLineData(id): any {
    this.url = APIs.getTimelineData;
    const paramObj = {
      MeetingRoomId: id,
      date: localStorage.getItem(AppConstant.localStorage.selectedDate)
    };
    return this.apiService.get(this.url, paramObj).pipe(map(response => {
      return response;
    }));

  }
  openMeetingRoomDetails(meeting) {
    if (this.selectedEmail === null || this.selectedEmail == '') {
      this.appStateSrv.showToast("Please Select The Host");
      return;
    }
    if (this.isDurationError)
      return this.appStateSrv.showToast('Duration should not be more than 12hrs');
    // if ((Number(this.displayTotalTimedetails.split(' ')[0].split(':')[0]) == 12 && this.displayTotalTimedetails.split(' ')[1].toLowerCase() == 'am') || (Number(this.displayTotalTimedetails.split(' ')[0].split(':')[0]) == 11 && Number(this.displayTotalTimedetails.split(' ')[0].split(':')[1]) > 45 && this.displayTotalTimedetails.split(' ')[1].toLowerCase() == 'pm')) {
    //   this.appStateSrv.showToast("Meeting time cannot exceed 11:45PM. Please select the valid time.");
    //   return;
    // }
    // if ((Number(this.displayTotalTimedetails.split(' ')[0].split(':')[0]) == 12 && this.displayTotalTimedetails.split(' ')[1].toLowerCase() == 'am') || (Number(this.displayTotalTimedetails.split(' ')[0].split(':')[0]) == 11 && Number(this.displayTotalTimedetails.split(' ')[0].split(':')[1]) > 45 && this.displayTotalTimedetails.split(' ')[1].toLowerCase() == 'pm') || (Number(this.displayTotalTimedetails.split(':')[0]) >= 1 && this.display.split(' ')[1] == 'pm' && this.displayTotalTimedetails.split(' ')[1].toLowerCase() == 'am')) {
    //   this.appStateSrv.showToast("Meeting time cannot exceed 11:45PM. Please select the valid time.");
    //   return;
    // }
    if (!this.checkIfValidTimeline(this.displayTotalTimedetails, this.displayDetails))
      return
    this.getNormalizeMinute(this.time.minute);
    var event = { hour: this.time.hour, minute: this.normalizeMinute };
    // console.log(event, 'event');

    if (this.validateTime(event))
      return;
    localStorage.setItem(
      AppConstant.localStorage.meeting,
      meeting.meetingRoom.id
    );
    localStorage.setItem(
      AppConstant.localStorage.bookingId,
      meeting.meetingRoom.t0300MeetingRoomBookings[0] ?
        meeting.meetingRoom.t0300MeetingRoomBookings[0].bookingId : 0
    );
    this.router.navigate(["/meeting/meetingroom-list/bookmeetingroomdetail"]);

  }

  getDataforTimeline() {

    this.availableData = [];
    this.flexibleData = [];
    this.meetingroomlist.list.forEach((item) => {

      this.getTimeLineData(item.meetingRoom.id).subscribe((timeLineResp) => {
        this.timelineData = timeLineResp;
        this.availableSlot = [];
        this.Data = [];

        // this.timelineData=response;
        // this.meetingroomlist.list.forEach((data)=>{
        this.timeLine = this.timelineData.list.filter(x => x.status == 'Active');
        if (this.timeLine.length > 0) {
          this.timeLine.forEach((data) => {
            // if(data.fromTime==this.display.toUpperCase() && data.toTime==this.displayTotalTime.toUpperCase())
            // {
            if (this.timelineData.fromTime == this.display.toUpperCase()) {
              // this.flexibleData=[]
              this.flexibleData.push(item);

            }
            else {
              this.availableData.push(item);
            }
            let bookedSlot = {
              startTime: data.fromTime,
              endTime: data.toTime
            };
            this.Data.push(bookedSlot);
            this.getTimelineTimeStamp(this.Data, true, item.meetingRoom.id);
            // }
            // else{
            let availableSlot = {
              startTime: this.display.toUpperCase(),
              endTime: this.displayTotalTime.toUpperCase()
              // endTime: '12:00 PM'
            }
            this.availableSlot.push(availableSlot);
            this.getTimelineTimeStamp(this.availableSlot, false, item.meetingRoom.id);
            // }
          })
          // }
        }
        else {
          // this.availableData=[]
          this.availableData.push(item);
          this.getTimelineTimeStamp(this.availableSlot, false, item.meetingRoom.id);
        }


        // else{
        //   this.backENdData=[];
        //   this.bookedData=[]
        // }

        // })

      })
      // this.getTimeLineData(data.id);
    })
  }
  getTimelineTimeStamp(Data, isBooked, meetingId) {
    // logic
    var i;
    var data: any[];
    data = [];
    var time, timeHour, timeMinutes;

    for (i = 0; i < Data.length; i++) {
      data[i] = [];
      // StartTime ****************
      time = Data[i].startTime.split(":");
      timeHour = parseInt(time[0]);
      if (Data[i].startTime.toUpperCase().includes(" PM")) {
        if (timeHour != 12) {
          timeHour = timeHour + 12;
        }
        timeMinutes = time[1].toUpperCase().replace(" PM", "");
      } else {
        if (timeHour == 12) {
          timeHour = 0;
        }
        timeMinutes = time[1].toUpperCase().replace(" AM", "");
      }
      if (timeMinutes == '00') {
        timeMinutes = '.00';
      }
      else if (timeMinutes <= '15') {
        timeMinutes = '.25';
      } else if (timeMinutes > '15' && timeMinutes <= '30') {
        timeMinutes = '.50';
      } else if (timeMinutes > '30') {
        timeMinutes = '.75';
      }
      else {
        timeMinutes = '.00';
      }

      data[i][0] = parseFloat(timeHour.toString() + timeMinutes);

      //EndTime*****************

      time = Data[i].endTime.split(":");
      timeHour = parseInt(time[0]);
      if (Data[i].endTime.toUpperCase().includes(" PM")) {
        if (timeHour != 12) {
          timeHour = timeHour + 12;
        }
        timeMinutes = time[1].toUpperCase().replace(" PM", "");
      } else {
        if (timeHour == 12) {
          timeHour = 0;
        }
        timeMinutes = time[1].toUpperCase().replace(" AM", "");
      }
      if (timeMinutes == '00') {
        timeMinutes = '.00';
      }
      else if (timeMinutes <= '15') {
        timeMinutes = '.25';
      } else if (timeMinutes > '15' && timeMinutes <= '30') {
        timeMinutes = '.50';
      } else if (timeMinutes > '30') {
        timeMinutes = '.75';
      }
      else {
        timeMinutes = '.00';
      }

      data[i][1] = parseFloat(timeHour.toString() + timeMinutes);

    }
    if (isBooked) {
      this.bookedData[meetingId] = data;

    }
    else {
      this.backENdData[meetingId] = data;
    }
  }
  public updateSelectedDate(date: NgbDate) {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

    if (jsDate < today) {
      this.appStateSrv.showToast("Cannot select past dates");
      return;
    }
    this.bookingDateinDt = jsDate;
    this.bookingDate = this.datepipe.transform(jsDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
    this.formatDate = this.dateSrv.convertDateToLocaleString(date.day, date.month - 1, date.year)
    if (jsDate.toDateString() != today.toDateString()) {
      localStorage.setItem(
        AppConstant.localStorage.changeHour,
        '7'
      );
      localStorage.setItem(
        AppConstant.localStorage.changeMinute,
        '0'
      );
      localStorage.setItem(
        AppConstant.localStorage.changeamorpm,
        'am'
      )
      // this.normalizeTime = { hour: 7, minute: 0 };
    }
    else {
      localStorage.setItem(
        AppConstant.localStorage.changeHour,
        '0'
      );
      localStorage.setItem(
        AppConstant.localStorage.changeMinute,
        '0'
      );
    }
    this.initiaizeStartTime();
    this.initializeDuration();
    localStorage.setItem(
      AppConstant.localStorage.bookingDate,
      this.bookingDate
    );
    localStorage.setItem(
      AppConstant.localStorage.selectedDate,
      this.datepipe.transform(jsDate, "yyyy-MM-dd")
    );
    this.getApiauthorizationToken();
  }

  getTenantCreditPoints() {
    this.meetingSrv.getTenantCredit().subscribe(response => {
      //console.log('credit response ', response);
      this.userCredits = response.list;
      this.userCredits.forEach(credit => {
        this.availableCredits = this.availableCredits + (credit.poolCreditPoints - credit.usedPoolCreditPoints)

      })
      if (this.availableCredits < 0)
        this.availableCredits = 0;
    })
    // localStorage.setItem(
    //   AppConstant.localStorage.availableCredits,
    //    this.availableCredits.toString()
    // );
  }

  ngOnInit(): void {
    this.model = localStorage.getItem(AppConstant.localStorage.selectedDate);
    localStorage.setItem(AppConstant.localStorage.bookingDate, localStorage.getItem(AppConstant.localStorage.selectedDate))
    const strDateTime = this.model;
    const arr = strDateTime.split(' ');
    const strDate = arr[0];
    const dateArr = strDate.split('/');
    const ngbDate: NgbDateStruct = {
      year: parseInt(dateArr[2], 10),
      month: parseInt(dateArr[1], 10),
      day: parseInt(dateArr[0], 10),
    }
    const jsDate = new Date();
    let strBookingDate = localStorage.getItem(
      AppConstant.localStorage.bookingDate);
    if (strBookingDate) {
      strBookingDate = new Date().toString();
      const bookingDate = new Date(strBookingDate);
      const ngbDate: NgbDateStruct = {
        year: bookingDate.getFullYear(),
        month: bookingDate.getMonth() + 1,
        day: bookingDate.getDate(),
      }
      this.model = ngbDate;
      this.bookingDateinDt = bookingDate;
      this.bookingDate = this.datepipe.transform(bookingDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
      this.formatDate = this.dateSrv.convertDateToLocaleString(Number(this.bookingDate.split('-')[2].split('T')[0]), Number(this.bookingDate.split('-')[1]) - 1, Number(this.bookingDate.split('-')[0]))
    }
    else {
      this.bookingDateinDt = jsDate;
      this.bookingDate = this.datepipe.transform(jsDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
      this.formatDate = this.dateSrv.convertDateToLocaleString(Number(this.bookingDate.split('-')[2].split('T')[0]), Number(this.bookingDate.split('-')[1]) - 1, Number(this.bookingDate.split('-')[0]))

    }
    localStorage.setItem(
      AppConstant.localStorage.bookingDate,
      this.bookingDate
    );
    const hostEmaild = localStorage.getItem(
      AppConstant.localStorage.hostEmaild);
    this.selectedEmail = hostEmaild ? { emailId: hostEmaild } : null;
    localStorage.removeItem(AppConstant.localStorage.changeMinute);
    localStorage.removeItem(AppConstant.localStorage.changeHour);
    // localStorage.removeItem(AppConstant.localStorage.changeamorpm);
    localStorage.removeItem(AppConstant.localStorage.duration);
    this.initiaizeStartTime();
    this.initializeDuration();
    //this.initializeSlider();
    this.getApiauthorizationToken();
    this.meetingNav = [
      {
        index: "2",
        name: "Meeting",
        link: '/meeting/meetingroom-list/bookmeetingroom'
      }
    ];

    const route = {
      index: "2",
      name: "Meeting",
      link: '/meeting/meetingroom-list/bookmeetingroom'
    };
    this.appStateSrv.setSideNavState(route);


    this.valuedate = 'Today,' + new Date();
    const seconds = true;
    let sum = 0;

    while (sum <= 24) {
      this.timeStamps.push(sum)
      sum += 0.5
    }

    this.getTenantCreditPoints();
  }
  getEmployeeEmailList() {

    this.url = APIs.getEmailid;
    const paramObj = {
      TenantId: localStorage.getItem(AppConstant.localStorage.tenantId)
    };
    this.apiService.get(this.url, paramObj).subscribe(
      (response: any) => {

        //this.emailList =response;
        this.emailList = response.list.filter(x => x.isActive);

      },
      err => console.log('error', err)
    );
  }
  //   toggleMeridian() {
  //     this.meridian = !this.meridian;
  // }
  onClickedOutside(e: Event) {
    // console.log('Clicked outside:', e);
  }
  openPopover(popover) {
    this.popOver = popover;
    if (popover.isOpen()) {
      popover.close();

    } else {
      popover.open();

    }
  }

  tempTimeConvertion(time) {
    let a = localStorage.getItem(time).split(' ')[1].toLowerCase() == 'pm' && Number(localStorage.getItem(time).split(':')[0]) < 12 ? Number(localStorage.getItem(time).split(':')[0]) + 12 : localStorage.getItem(time).split(' ')[1].toLowerCase() == 'am' && Number(localStorage.getItem(time).split(':')[0]) == 12 ? 0 : Number(localStorage.getItem(time).split(':')[0]);
    // if (a == 12)
    //   a = 0;
    let b = localStorage.getItem(time).split(':')[1].split(' ')[0] == '00' ? 0 : localStorage.getItem(time).split(':')[1].split(' ')[0] == '45' ? 0.75 : 0.25;
    return a + b;
  }
  prepare(val, meetingroom) {

    // console.log('backENdData ', this.backENdData, 'val', val, 'meetingrrom', meetingroom, 'timeStamps', this.timeStamps, 'bookedData', this.bookedData);

    let data = {
      value: val,
      higlight: false,
      type: 's',
      bookedhiglight: false,
      show: false
    }
    if (val % 1 == 0)
      data.type = 'b';
    else {
      if (val % 0.5 == 0)
        data.type = 's';
      else
        data.type = 's';
    }
    // data.higlight = this.backENdData.some(item => val > item[0] && val <= item[1])
    // data.bookedhiglight = this.bookedData.some(item => val > item[0] && val <= item[1])




    let start = this.tempTimeConvertion('fromTime');
    let end = start + Number(localStorage.getItem('duration'));
    if (end >= 24)
      end = end - 24;
    if (end == 0)
      end = 24;
    let selectedTimeLine = [];
    let timeline = [];
    // selectedTimeLine = this.backENdData[meetingroom.id];
    selectedTimeLine = [start, end];
    let temp = selectedTimeLine[0];
    if (temp % 1 == 0.75 || temp % 1 == 0.25)
      temp = temp - 0.25;
    temp = (temp + 0.5 > 24) ? (temp + 0.5) - 24 : (temp + 0.5);
    if (selectedTimeLine[0] % 1 == 0)
      timeline.push(temp);
    while (selectedTimeLine[1] > temp) {
      temp = ((temp + 0.5) > 24) ? (temp + 0.5) - 24 : (temp + 0.5);
      if (temp % 1 == 0.75 || temp % 1 == 0.25)
        temp = temp - 0.25;
      timeline.push(temp);
    }



    data.higlight = timeline.some(a => a == val);

    // for (let key in this.bookedData) {
    if (this.bookedData[meetingroom.id] !== undefined)
      data.bookedhiglight = this.bookedData[meetingroom.id].some(item => meetingroom.id == meetingroom.id && val >= item[0] && val <= item[1]);
    else
      data.bookedhiglight = false;

    if (val == 7) {
      data.higlight = false;
      data.bookedhiglight = false
    }

    // }
    if (val % 2 == 0) {
      data.show = true
    }
    else {
      data.show = false
    }
    if (val > 12) {
      data.value = val - 12 + '' + 'pm'
    }
    else {
      data.value = val + '' + 'am'
    }
    if (data.value == '0am')
      data.value = '12am';
    else if (data.value == '12pm')
      data.value = '12am';
    else if (data.value == '12am')
      data.value = '12pm';
    // console.log('final data ', data);

    return data
  }
  selectEmailid(item) {
    this.selectedIndex = item.id;
    this.selectedEmail = item.user;

    localStorage.setItem(
      AppConstant.localStorage.hostEmaild,
      item.user.emailId
    );

    localStorage.setItem(
      AppConstant.localStorage.selectedHost,
      JSON.stringify(item.user)
    );


    this.highlight = !this.highlight;
  }
  ngOnDestroy() {
    clearInterval(this.timer);
  }
  addTime(time) {
    this.duration = this.duration + 0.30;
    this.timer = this.timeToDisplay + this.duration;
  }
  subtractTime(time) {
    this.duration = this.duration - 0.30;
  }
  getDatetime(value: { hour: string, minute: string }) {
    if (this.time) {
      this.time = {
        hour: new Date().getHours(),
        minute: new Date().getMinutes()
      };

    }
  }
  validateTime(event) {
    const today = new Date();
    // if (this.popOver)
    //   this.popOver.close();
    // if (event.hour == 0)
    //   this.amorpm = false;
    // if (event.hour == 12)
    //   this.amorpm = true;
    // if ((event.hour < 7 || event.hour >= 12) && !this.amorpm) {
    //   // this.amorpm = true;
    //   this.appStateSrv.showToast('Selected time is before 7 AM. Please select the valid time.');
    //   return true;
    // }
    // if (this.amorpm && ((event.hour > 18 && event.minute >= 0) || ((event.hour == 6 || event.hour == 18) && event.minute > 1 ||
    //   (event.hour >= 7 && event.hour < 12 && event.minute >= 0)))) {
    //   this.appStateSrv.showToast('The selected time is beyond limit. Please select the valid time.');
    //   return true;
    // }
    if (this.bookingDateinDt.toDateString() == today.toDateString()) {
      const eventHour = this.amorpm == true ? event.hour + 12 : event.hour;
      if (eventHour < today.getHours() || (eventHour == today.getHours() && event.minute < today.getMinutes())) {
        this.appStateSrv.showToast('Cannot select past times.');
        return true;
      }
    }
  }
  onTimeChange(event) {
    if (this.validateTime(event)) {
      return;
    }

    event.minute = event.minute > 60 ? 0 : event.minute;
    if (event.minute % 15 !== 0) {
      if (event.minute < 15)
        event.minute = 15;
      else if (event.minute > 15 && event.minute < 30)
        event.minute = 30;
      else if (event.minute > 30 && event.minute < 45)
        event.minute = 45;
      else if (event.minute > 45 && event.minute < 60) {
        event.minute = 0
        event.hour++;
      }
    }
    event.hour = event.hour > 12 ? event.hour - 12 : event.hour;
    let minute
    let amorpm: any;
    this.time = {
      hour: event.hour,
      minute: event.minute
    };
    let normalizeHour = event.hour > 12 ? event.hour - 12 : event.hour;
    // if (normalizeHour == 12 && !this.amorpm && Number(this.displayDetails.split(':')[0]) !== 1)
    //   this.amorpm = true;
    if ((Number(this.displayDetails.split(':')[0]) == 12 && normalizeHour == 11) || (Number(this.displayDetails.split(':')[0]) == 11 && (normalizeHour == 12 || normalizeHour == 0)))
      this.amorpm = !this.amorpm;
    if (this.amorpm) {
      amorpm = 'pm';
    }
    else {
      amorpm = 'am';
    }

    localStorage.setItem(
      AppConstant.localStorage.changeamorpm,
      amorpm
    );
    this.getNormalizeMinute(event.minute);
    let len = event.minute.toString().length;
    if (len == 1) {
      minute = '0' + event.minute;
    }
    else {
      minute = event.minute;
    }
    this.normalamorpm = amorpm;
    this.normalizeTime.hour = normalizeHour;
    normalizeHour = normalizeHour == 0 ? 12 : normalizeHour;
    this.display = event.hour >= 13 ? normalizeHour + ':' + minute + ' ' + amorpm.toUpperCase() : normalizeHour + ':' + minute + ' ' + amorpm.toUpperCase();
    this.displayDetails = event.hour >= 13 ? normalizeHour + ':' + minute + ' ' + amorpm.toUpperCase() : normalizeHour + ':' + minute + ' ' + amorpm.toUpperCase();
    let duration = {
      hour: 0,
      minute: 30
      // endTime: '12:00 PM'
    }
    localStorage.setItem(
      AppConstant.localStorage.fromtime,
      this.displayDetails
    );
    this.onDurationChange(duration)
    this.newTime = `${event.hour}:${event.minute}`;
    localStorage.setItem(
      AppConstant.localStorage.changeHour,
      event.hour
    );
    localStorage.setItem(
      AppConstant.localStorage.changeMinute,
      event.minute
    );
    this.getApiauthorizationToken();
  }

  onDurationChange(event) {
    // if (event.hour < 13) {

    if (event.hour <= 0) {
      this.isDurationError = true;
      return this.appStateSrv.showToast('Duration should be more than 1hr');
    }
    else if (event.hour > 12 || (event.hour == 12 && event.minute > 0)) {
      event.hour = 12;
      event.minute = 0;
      this.isDurationError = true;
      return this.appStateSrv.showToast('Duration should not be more than 12hrs');
    }
    this.isDurationError = false;


    if (event.hour == 0)
      event.hour = 0;
    // event.hour = event.hour >= 13 ? event.hour - 12 : event.hour;
    if (event.hour >= 12 && event.minute > 0)
      event.hour = 1;

    event.minute = event.minute > 60 ? 0 : event.minute;
    if (event.minute % 15 !== 0) {
      if (event.minute < 15)
        event.minute = 15;
      else if (event.minute > 15 && event.minute < 30)
        event.minute = 30;
      else if (event.minute > 30 && event.minute < 45)
        event.minute = 45;
      else if (event.minute > 45 && event.minute < 60) {
        event.minute = 0
        event.hour++;
      }
    }
    // event.hour = event.hour > 12 ? event.hour - 12 : event.hour;

    if (event.hour >= 12 && event.minute > 0)
      event.hour = 1;
    // console.log('event ', event);
    //if (event.hour <= 0) {
    //alert("Duration should be more than 1hr");
    //return;
    //}
    let amorpm;
    let minute;
    let min;
    this.duration = {
      hour: event.hour,
      minute: event.minute
    };

    let normalizeHour = event.hour == 1 ? event.hour + ' hour' : event.hour + ' hours'

    let normalizeMinutes = event.minute == 0 ? '' : event.minute + ' minutes'
    this.displayDuration = normalizeHour + ' ' + normalizeMinutes;
    this.displayDurationdetails = event.hour + ':' + (event.minute <= 10 ? "0" + event.minute : event.minute);
    this.displayDurationdetails = event.hour + '.' + event.minute;
    localStorage.setItem(
      AppConstant.localStorage.duration,
      this.displayDurationdetails
    );
    // this.newTime=`${event.hour}:${event.minute}`;
    let hour = parseInt(event.hour) + parseInt(this.normalizeTime.hour);
    let minutes = parseInt(event.minute) + parseInt(this.normalizeTime.minute);
    if (minutes >= 60) {
      hour = hour + 1
    }
    let normalizeDisplayTime = hour >= 13 ? hour - 12 : hour

    if (minutes == 60) {
      minutes = 0;
      // normalizeDisplayTime = normalizeDisplayTime + 1;
      normalizeDisplayTime = normalizeDisplayTime;
    }

    minutes = minutes >= 60 ? minutes - 60 : minutes;

    if (this.normalamorpm == 'am') {
      amorpm = 'pm';
    }
    else {
      amorpm = 'am';
    }
    amorpm = hour >= 12 ? amorpm : this.normalamorpm;

    let len = minutes.toString().length;
    if (len == 1) {
      minute = '0' + minutes;
    }
    else {
      minute = minutes;
    }
    if (minutes <= 10) {
      min = "0" + minutes
    }
    else {
      min = minutes;
    }

    if(normalizeDisplayTime == 0) {
      normalizeDisplayTime = 12;
    }
    
    if (this.normalizeTime.hour >= 12 && this.normalamorpm == 'am')
      amorpm = 'am';
    if (this.normalizeTime.hour >= 12 && this.normalamorpm == 'pm')
      amorpm = 'pm';
    this.displayTotalTime = normalizeDisplayTime + ':' + minute + ' ' + amorpm.toUpperCase();
    this.displayTotalTimedetails = normalizeDisplayTime + ':' + minute + ' ' + amorpm.toUpperCase();
    // if ((Number(this.displayTotalTimedetails.split(' ')[0].split(':')[0]) == 12 && this.displayTotalTimedetails.split(' ')[1].toLowerCase() == 'am') || (Number(this.displayTotalTimedetails.split(' ')[0].split(':')[0]) == 11 && Number(this.displayTotalTimedetails.split(' ')[0].split(':')[1]) > 45 && this.displayTotalTimedetails.split(' ')[1].toLowerCase() == 'pm')) {
    //   this.appStateSrv.showToast("Meeting time cannot exceed 11:45PM. Please select the valid time.");
    //   console.log('in onDurationChange');

    //   return;
    // }

    // if ((Number(this.displayTotalTimedetails.split(' ')[0].split(':')[0]) == 12 && this.displayTotalTimedetails.split(' ')[1].toLowerCase() == 'am') || (Number(this.displayTotalTimedetails.split(' ')[0].split(':')[0]) == 11 && Number(this.displayTotalTimedetails.split(' ')[0].split(':')[1]) > 45 && this.displayTotalTimedetails.split(' ')[1].toLowerCase() == 'pm') || (Number(this.displayTotalTimedetails.split(':')[0]) >= 1 && this.display.split(' ')[1] == 'pm' && this.displayTotalTimedetails.split(' ')[1].toLowerCase() == 'am')) {
    //   this.appStateSrv.showToast("Meeting time cannot exceed 11:45PM. Please select the valid time.");
    //   return;
    // }
    if (!this.checkIfValidTimeline(this.displayTotalTimedetails, this.displayDetails))
      return


    localStorage.setItem(
      AppConstant.localStorage.toTime,
      this.displayTotalTimedetails
    );
    //this.getDataforTimeline();
    this.getApiauthorizationToken();
    // }
  }
  toggleMeridian() {
    this.meridian = !this.meridian;
  }
  toggleAmPmSelection(value: boolean) {
    this.amorpm = value;
    this.onTimeChange(this.normalizeTime);
  }
}
